import api from './api'

const filenameFrom = (disposition: string | undefined, fallback: string) => {
    const match = disposition?.match(/filename="?([^";]+)"?/)
    return match ? match[1] : fallback
}

/**
 * Fetch a file through the authenticated API client and hand it to the browser
 * as a download. A plain link cannot be used because the JWT lives in a header.
 */
export const downloadFile = async (url: string, fallbackName: string): Promise<string | undefined> => {
    const resp = await api.get<Blob>(url, { responseType: 'blob' })
    if (resp.error || !resp.data) {
        return typeof resp.error === 'string' ? resp.error : 'download_failed'
    }
    const objectUrl = URL.createObjectURL(resp.data)
    const anchor = document.createElement('a')
    anchor.href = objectUrl
    anchor.download = filenameFrom(resp.headers?.['content-disposition'], fallbackName)
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
    URL.revokeObjectURL(objectUrl)
    return undefined
}
